module.exports = __webpack_public_path__ + "assets/Plus-Accent.d9ec4d3f.svg";